import { calculatePickScore } from "./pickScore";
import { pickMissPenalty } from "./skillEffects";

const PHISHING_FALSE_POSITIVE_PENALTY = 4;

/** Normalized Phishing triage score (0-100), same shape as Log Analysis. */
export function calculatePhishingScore(
  emails: readonly { isPhishing: boolean }[],
  selectedIndexes: ReadonlySet<number>,
  phishingLevel = 0,
): number {
  return calculatePickScore(
    emails.map((email) => ({ positive: email.isPhishing })),
    selectedIndexes,
    pickMissPenalty(phishingLevel),
    PHISHING_FALSE_POSITIVE_PENALTY,
  );
}
